import { Body } from "playbook-ui";

const PbBody = Body;

export default PbBody